import { connect } from "react-redux";
import goalsToWatch from "../../../global/goalsToWatch/goalsToWatchModule";
import { actionCreators } from "../redux/sagas/goalsSummary/goalsSummary";
import { formatGoalTitle } from "../../../../utils/formatters";
import { getGoalValue, getForecastValue } from "../../../../modules/goals/goalsModule";

export function formatGoalsData(data) {
  let cleanedData = [];
  data.map(item => {
    cleanedData.push({
      id: item.id,
      locationName: item.locationName,
      metricTitle: item.title,
      value: getGoalValue(item),
      projectedValue: getForecastValue(item),
      currentVal: item.currentVal,
      currentValPacing: item.currentValPacing,
      currencySymbol: item.currencySymbol
    });
  });
  return cleanedData;
}

export function formatList(data) {
  let finalList = [];

  data.revenue.map(item => {
    if (item.active) {
      finalList.push({
        preLabel: item.locationName,
        label: formatGoalTitle(item.title),
        value: item.id
      });
    }
  });

  data.attendance.map(item => {
    if (item.active) {
      finalList.push({
        preLabel: item.locationName,
        label: formatGoalTitle(item.title),
        value: item.id
      });
    }
  });

  data.memberships.map(item => {
    if (item.active) {
      finalList.push({
        preLabel: item.locationName,
        label: formatGoalTitle(item.title),
        value: item.id
      });
    }
  });

  data.retention.map(item => {
    if (item.active) {
      finalList.push({
        preLabel: item.locationName,
        label: formatGoalTitle(item.title),
        value: item.id
      });
    }
  });
  return finalList;
}

export default connect(
  state => ({
    title: "Goals to Watch",
    moduleName: ".react-section-wrapper.goals-summary",
    checkList: formatList(state.goalsSummary.goalsList),
    selectHeight: "600px",
    data: formatGoalsData(state.goalsSummary.goalsToWatch),
    defaultCheckedItems: state.goalsSummary.goalsToWatch,
    currentUser: state.goalsSummary.currentUser,
    singleLocation: state.goalsSummary.currentUser.singleLocation
  }),
  {
    onSubmit: data => {
      return actionCreators.setGoalsToWatch(data);
    }
  }
)(goalsToWatch);
